export const MAX_SIZE = 140
